import { useEffect } from 'react';
import { C2Button } from '../c2';
import { track } from '../../lib/analytics';

interface UseExtensionModalProps {
  open: boolean;
  onClose: () => void;
}

export default function UseExtensionModal({ open, onClose }: UseExtensionModalProps) {
  useEffect(() => {
    if (!open) return;
    track('ext_required_modal_shown', { reason: 'create' });
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleInstallClick = () => {
    track('ext_required_modal_clicked_install');
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[100]"
      style={{ background: 'oklch(0.2 0.02 260 / 0.4)', padding: 20 }}
      onClick={onClose}
    >
      <div
        className="w-full bg-surface overflow-hidden"
        style={{
          maxWidth: 480,
          borderRadius: 28,
          boxShadow: 'var(--shadow-lg)',
          border: '1px solid var(--color-hairline)',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: '26px 28px 22px', borderBottom: '1px solid var(--color-hairline)' }}>
          <div className="flex items-start justify-between gap-4">
            <div>
              <div
                className="font-display font-bold text-ink"
                style={{ fontSize: 22, letterSpacing: '-0.01em' }}
              >
                Create links from the extension
              </div>
              <div className="text-[13.5px] text-ink-soft mt-1.5 leading-[1.5]">
                Tidy is built around the browser extension — pin it, then click the icon on any
                page to turn the URL into a <span className="font-mono font-semibold text-ink">go/</span> link.
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center bg-transparent border-0 cursor-pointer text-ink-muted shrink-0"
              style={{ borderRadius: 8 }}
              aria-label="Close"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
        </div>

        <div
          className="flex items-center justify-between gap-3"
          style={{ padding: '16px 28px', background: 'var(--color-bg-alt)' }}
        >
          <a
            href="/onboarding"
            onClick={handleInstallClick}
            className="text-[13px] font-semibold text-ink-soft hover:text-ink transition-colors"
            style={{ textDecoration: 'none' }}
          >
            Need help installing?
          </a>
          <C2Button variant="accent" size="sm" onClick={onClose}>Got it</C2Button>
        </div>
      </div>
    </div>
  );
}
